module.exports = __webpack_public_path__ + "img/SN-B.cb4dc97f.png";